import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/adsBlock/AdsBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/buttonClicks/ClickHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaticProductContainer"] */ "/vercel/path0/src/app/components/product/staticProductContainer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/posts/[slug]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/search/[searchTerm]/clientComponent.tsx");
